"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_LOCALE = 'en';
/**
 * Return the user locale based on browser's language.
 *
 * @returns The user locale.
 */

exports.getUserLocale = function () {
  if (typeof navigator !== 'undefined') {
    return (navigator.languages || []).length ? navigator.languages[0] : navigator.language;
  }

  return exports.DEFAULT_LOCALE;
};